import { DynamicFormV2Palette } from "@mui/material";

export type FormGlobalTokenType = {
  focusOutlineColor: string;
  scrollbarThumbColor: string;
};

export const assignGlobalTokens = (formsPalette: DynamicFormV2Palette["forms"]) => {
  return {
    focusOutlineColor: formsPalette.border.quiet,
    scrollbarThumbColor: formsPalette.surface.quiet,
  } as FormGlobalTokenType;
};
